import i18n from 'services/base/i18n';

export default {
  // Title text on the power up your pangolin page
  title: () => i18n.pgettext('Pages|Add Pangolin|Power Up', 'Power up'),

  // Instructions telling users to power up the Pangolin
  instructions: () => i18n.pgettext('Pages|Add Pangolin|Power Up', 'Connect the Pangolin device to a power outlet.'),

  // Text for the link to continue to the next page
  next: () => i18n.pgettext('Pages|Add Pangolin|Power Up', 'NEXT'),
};
